import { useMutation } from '@tanstack/react-query';
import type {
  CreateSavedBankAddressRequestDto,
  CreateSavedBankAddressResponseDto,
} from '../../model';
import { createSavedBankAddress } from '../requests';

interface Options {
  onSuccess?: (data: CreateSavedBankAddressResponseDto) => void;
  onError?: (error: Error) => void;
}

export function useCreateBankAddress({ onSuccess, onError }: Options = {}) {
  const mutation = useMutation<
    CreateSavedBankAddressResponseDto,
    Error,
    CreateSavedBankAddressRequestDto
  >({
    mutationFn: args => createSavedBankAddress(args),
    onSuccess,
    onError,
  });

  return {
    mutate: mutation.mutate,
    mutateAsync: mutation.mutateAsync,
    data: mutation.data,
    isPending: mutation.isPending,
    error: mutation.error,
  };
}
